import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { useSession } from '@/services/providers/session-provider.tsx';
import { NotificationRule } from '@/features/notification-rules/schemas/notification-rules.schema.ts';

export const useGetUserNotificationRulesQuery = () => {
  const { userId } = useSession();

  return useQuery({
    queryKey: ['users', userId, 'notification-rules'],
    queryFn: async () => {
      const { data } = await client.get<{ body: NotificationRule[] }>(
        `/users/${userId}/notification-rules`
      );

      return data.body;
    },
    refetchInterval: 1000 * 60 * 5,
  });
};
